<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.0002 15.9998C13.3088 15.9998 16 13.3083 16 9.99966C16 6.69163 13.308 4.00013 10.0002 4.00013C6.69701 4.00013 4.00012 6.69644 4.00012 9.99966C4.00012 13.3085 6.69133 15.9998 10.0002 15.9998ZM20.5862 21.9998L14.9002 16.3135C13.5438 17.3697 11.8425 17.9999 10.0002 17.9999C5.59801 17.9999 2 14.4019 2 9.99966C2 5.59292 5.59347 2 10.0002 2C14.4021 2 18.0002 5.59774 18.0002 9.99966C18.0002 11.8413 17.3703 13.5427 16.3141 14.8996L22.0001 20.5859L20.5862 21.9998Z"
      fill="currentColor"
    />
  </svg>
</template>
